<form [formGroup]="formGroup" class="flex flex-col justify-between">
  <ng-container formArrayName="comment">

      <div [formGroup]="newComment" class="h-full flex flex-row">

        <div class="flex flex-row w-full gap-4 justify-center items-end">
          <!--          <form class="w-full">-->
          <div class="w-full mb-4">
            <bic-textarea
              placeholder="Kommentar hinzufügen"
              formControlName="comment"
              id="comment"
              [rows]="1"></bic-textarea>
            <!--              </div>-->
          </div>
          <bic-button (onClick)="addComment(newComment.value)" buttonType="white" class="mb-4" [disabled]="actionsDisabled">Senden
            <fa-icon [icon]="faPaperPlaneTop" iconLeft></fa-icon>
          </bic-button>
          <!--          </form>-->
        </div>

        <!--        -->
        <!--        <angular-editor formControlName="comment" class="pr-5"-->
        <!--                        [config]="editorConfig"></angular-editor>-->
        <!--        <button mat-raised-button class="!bg-white" (click)="addComment(newComment.value)">Senden</button>-->
      </div>

      <div class="flex flex-col w-full h-[135px] overflow-hidden">
        <div class="flex flex-col w-full h-full overflow-y-scroll gap-4">
          @for (commentForm of comments.controls; track commentForm; let i = $index) {
            <div>
              <div class="flex flex-col w-full gap-1">
                <div class="flex flex-row w-full justify-between">
                  <div class="flex flex-row items-center gap-2">
                    @if (comment(i)?.authorUser?.profileImage && !comment(i)?.authorUser?.profileImage?.toLowerCase()?.includes('defaultimages/profile.png')) {
                      <img (error)="comment(i)!.authorUser.profileImage = undefined" alt="Verantwortlicher"
                           class="w-6 h-6 rounded-full"
                           src="{{comment(i)?.authorUser?.profileImage}}">
                    } @else {
                      <div
                        class="relative inline-flex items-center justify-center w-6 h-6 overflow-hidden bg-gray-100 rounded-full">
                <span
                  class="font-medium text-xs text-green">{{ comment(i)?.authorUser?.firstName?.charAt(0)?.toUpperCase() }}{{ comment(i)?.authorUser?.lastName?.charAt(0)?.toUpperCase() }}</span>
                      </div>
                    }
                    <span
                      class="text-xs font-medium text-gray">{{ comment(i)?.authorUser?.firstName }} {{ comment(i)?.authorUser?.lastName }}</span>
                    <span
                      class="text-xs font-medium text-gray pl-1">{{ $safeNavigationMigration(comment(i)?.date) | date: "dd/MM/yyyy" }}</span>
                    <!--                    @if (comment(i)?.modifiedDate) {-->
                    <!--                      <span-->
                    <!--                        class="text-sm text-gray-600">• Geändert am {{ comment(i)?.modifiedDate | date: "dd.MM.yyyy" }}</span>-->
                    <!--                    }-->
                  </div>
                  <div [bicDropdownTrigger]="dropdown" class="hover:cursor-pointer flex w-4 justify-center">
                    <fa-icon [icon]="faEllipsisVertical" class="text-sm text-gray"></fa-icon>
                  </div>
                </div>
                <div class="flex flex-row w-full text-xs font-normal text-gray pl-8 pr-2">
                  {{ comment(i)?.comment }}
                </div>
                <!--            <div class="flex flex-row w-full gap-4">-->
                <!--              <span class="text-sm text-gray-500">Bearbeiten</span>-->
                <!--              <div class="flex flex-row gap-1">-->
                <!--                <fa-icon class="text-sm text-gray-400" [icon]="faReply"></fa-icon>-->
                <!--                <span class="text-sm text-gray-500">Antworten</span>-->
                <!--              </div>-->
                <!--            </div>-->
              </div>
              <bic-dropdown #dropdown [dropdownPlacement]="'bottom-start'">
                <!--            <bic-dropdown-element>-->
                <!--              <div class="flex flex-row text-sm gap-3 text-gray-700">-->
                <!--                <fa-icon class="text-gray-700" [icon]="faReply"></fa-icon>-->
                <!--                <span>Antworten</span>-->
                <!--              </div>-->
                <!--            </bic-dropdown-element>-->
                <!--            <bic-dropdown-element (click)="setEditComment(i,true)">-->
                <!--              <div class="flex flex-row text-sm gap-3 text-gray-700">-->
                <!--                <fa-icon class="text-gray-700" [icon]="faPenToSquare"></fa-icon>-->
                <!--                <span>Bearbeiten</span>-->
                <!--              </div>-->
                <!--            </bic-dropdown-element>-->
                <!--            <bic-seperator></bic-seperator>-->
                <bic-dropdown-element (onClick)="deleteComment(i)" [disabled]="actionsDisabled">
                  <div class="flex flex-row text-sm gap-3 text-red">
                    <fa-icon [icon]="faTrash" class="text-red"></fa-icon>
                    <span>Löschen</span>
                  </div>
                </bic-dropdown-element>
              </bic-dropdown>
            </div>
          }
        </div>
      </div>
  </ng-container>
</form>
